/**
 * Return the navigation information for a given activity type and key
 * This function can be used for logs and todos
 * All possible todos and logs MUST be handled here
 * Check backend with commands:
 *      > python manage.py show_activities
 * @param activityName
 * @param activityKey
 */
export function getActivityNavigationInfo(activityName: string, activityKey?: string | null) {
    if (activityName == "InvitationNeedResponse") {
        return {
            name: "WorkerInvitationDetails",
            params: {
                invitationId: activityKey as string,
            },
        } as const;
    }
    if (
        activityName == "ContractWorkerNeedSign" ||
        activityName == "ContractClientNeedSign" ||
        activityName == "ContractContinueSigning"
    ) {
        return {
            name: "ContractPreviewScreen",
            params: { contractId: activityKey as string },
        } as const;
    }
    if (activityName == "VerifyEmail") {
        return {
            name: "ResendEmailVerification",
            params: undefined,
        } as const;
    }
    if (activityName == "WorkerNeedCompletion") {
        return {
            name: "Home",
            params: { screen: "ProfileStack" },
        } as const;
    }
    if (activityName == "TimeSheetNeedCompletion") {
        return {
            name: "TimesheetWorkerInput",
            params: { id: activityKey as string },
        } as const;
    }
    if (activityName == "TimeSheetNeedChanges") {
        return {
            name: "TimesheetWorkerInput",
            params: { id: activityKey as string },
        } as const;
    }
    if (activityName == "TimeSheetNeedReview") {
        return {
            name: "TimesheetClientReview",
            params: { id: activityKey as string },
        } as const;
    }
    if (activityName === "EmailVerified") {
        return null;
    }
    if (activityName === "InvitationSelfAccepted") {
        return null;
    }
    if (activityName === "InvitationOtherAccepted") {
        return null;
    }
    if (activityName === "InvitationSelfRejected") {
        return null;
    }
    if (activityName === "InvitationOtherRejected") {
        return null;
    }
    if (activityName === "SalaryPaid") {
        return {
            name: "SalaryDetails",
            params: {
                salaryId: activityKey as string,
            },
        } as const;
    }
    if (activityName === "NewInvoiceAvailable") {
        return {
            name: "InvoiceDetails",
            params: {
                invoiceId: activityKey as string,
            },
        } as const;
    }
    if (
        activityName.startsWith("ContractSignedFor") ||
        activityName.startsWith("ContractAcceptedFor") ||
        activityName.startsWith("ContractCanceledBy") ||
        activityName.startsWith("ContractTerminatedBy") ||
        activityName.startsWith("ContractEndedFor")
    ) {
        return {
            name: "MissionDetails",
            params: { missionId: activityKey as string },
        } as const;
    }
    if (activityName === "TimeSheetAccepted") {
        return {
            name: "TimesheetWorkerReview",
            params: { id: activityKey as string },
        } as const;
    }
    if (activityName === "PayrollBreakdownNeedCompletion") {
        return {
            name: "PayrollBreakdownEditor",
            params: { payrollBreakdownId: activityKey as string },
        } as const;
    }
    return null;
}

export const getActivityTitle = (title: string) => {
    if (title === "__APP_NAME__") {
        return "Lift";
    }
    return title;
};
